import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import $ from 'jquery';
import {
    setPlayerRecomendationKey,
    showPlayerRecomMobPopUp
} from '../../../actions/FormationActions';
import common from '../../../common';
import OutsideNotifier from '../../../OutsideNotifier';
import config from './../../../config';


class PlayerRecomendationMobPopList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dropDownHeight: {}
        }
    }

    closePop = (e, val) => {
        this.props.showPlayerRecomMobPopUp(val)

    }

    selectSugestion = (e, obj) => {
        //
        e.stopPropagation();
        if (this.props.playerRecomendedSelectedKey == obj.Key) {

        } else {
            this.props.setPlayerRecomendationKey(obj);
            common.customTracking('Select Player Recomendation Filter - ' + (config.playerRecomendationTrans[obj.Key] ? config.playerRecomendationTrans[obj.Key] : obj.Key), common.getPageName());

        }
        this.props.showPlayerRecomMobPopUp(false)
    }

    componentDidMount() {
        this.setState({
            dropDownHeight: common.setDropDownHeight("#playerRecomendationDropDown", 45, this.props.playerRecomendationKeys.length)
        })

    }

    render() {
        const { trans, onRecomendationPopUpClose } = this.props;

        return <OutsideNotifier handler={ (e) => this.closePop(e, false) }> <div className="si-tooltip si-recommend-tt">
            <ul className="si-dropdown-options" id="playerRecomendationDropDown" style={ this.state.dropDownHeight }>

                { this.props.playerRecomendationKeys.map((obj) => {
                    const className = common.makeClasses({
                        'si-active': obj.Key == this.props.playerRecomendedSelectedKey
                    })
                    return <li className={ className } key={ obj.Key } onClick={ (e) => { this.selectSugestion(e, obj) } }>
                        <span>{ trans[obj.Key] ? trans[obj.Key] : obj.Key }</span>
                    </li>
                }) }
            </ul>
        </div>
        </OutsideNotifier>

    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        playerRecomendationKeys: state.formationData.playerRecomendationKeys,
        playerRecomendedSelectedKey: state.formationData.playerRecomendedSelectedKey
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setPlayerRecomendationKey: (obj) => dispatch(setPlayerRecomendationKey(obj)),
        showPlayerRecomMobPopUp: (bool) => dispatch(showPlayerRecomMobPopUp(bool))
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PlayerRecomendationMobPopList));


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/PlayerRecomendationMobPopList.js